<script setup lang="ts">
import type {FileInputState} from "./file-input-state.ts";

defineProps<{
  state: FileInputState,
}>();
</script>

<template>
  <div
      class="c-FileInputDefaultHoverModal"
      :class="{'drop-hover': state.private.dropHover.value}"
      data-component="FileInputDefaultHoverModal"
  >
    <div class="bottom-shadow"></div>
  </div>
</template>

<style scoped>
.c-FileInputDefaultHoverModal {
  height: 100%;
  width: 100%;
  position: fixed;
  pointer-events: none;
  transition: opacity 0.25s ease-out;
  opacity: 0;
}
.c-FileInputDefaultHoverModal.drop-hover {
  opacity: 1;
}
.c-FileInputDefaultHoverModal .bottom-shadow {
  position: fixed;
  bottom: 0;
  left: 0;
  height: 50px;
  width: 100%;
  background-image: linear-gradient(to top, rgba(0,0,0,0.15), rgba(0,0,0,0.005));
}
</style>